module.exports = __webpack_public_path__ + "img/shenzong.cb0fe76a.png";